module.exports = __webpack_public_path__ + "img/video_1.5e27272e.jpg";